<template>
  <div class="data-list content-text">
    <span>{{ title }}</span
    >{{ value }}
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
<style lang="scss">
.data-list {
  margin-bottom: 10px;
  span {
    color: #3c3c3c;
    font-weight: 500;
    margin-right: 1rem;
  }
}
</style>
